<template>
  <auth-shell>
    <div class="text-center">
      <img class="validate-illustration" src="/img/island-animated.svg" />
      <h4 class="auth-title">Check Your Email</h4>
      <p class="auth-subtitle">
        We sent an email link to complete your registration.
      </p>
      <p class="auth-body-text">
        <strong
          >Tip: Check your spam folder in case the email was incorrectly
          identified.</strong
        >
      </p>
    </div>
  </auth-shell>
</template>

<script>
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
};
</script>

<style scoped>
.validate-illustration {
  height: 100px;
  margin-bottom: 25px;
}
</style>
